import React, { Component } from 'react';
import Overlay from './Overlay';
import Button from './Button';
import { Colours } from '../Common/Colours';

export default class ConfirmMessage extends Component {
	constructor(props) {
		super(props);
		this.state = {

		};
	};

	handleOnClick = (bool) => {
		this.props.handleClick(bool)
	}

	render() {
		let box_style = {
			color: 'black',
			backgroundColor: 'white',
			minHeight: 150,
			width: this.props.width > 525 ? '40%' : this.props.width * 0.9,
			left: this.props.width > 525 ? this.props.width * 0.3 : this.props.width * 0.05,
			position: 'absolute',
			top: (this.props.height - 200) / 2,
			zIndex: 1,
			borderRadius: 10,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		};

		let message_style = {
			paddingLeft: 10,
			paddingRight: 10,
		}

		let style = {
			display: this.props.is_show ? 'block' : 'none',
			zIndex: 1,
			position: 'absolute'
		}

		style = Object.assign(style, this.props.style);
		box_style = Object.assign(box_style, this.props.box_style);

		let colours = window.app != null ? window.app.state.colours : Colours.light;

		return (
			<div style={style} className={this.props.is_show ? 'slideInDown' : 'slideOutUp'}>
				<Overlay backgroundColor={'rgba(238, 238, 238, 0.95)'} width={this.props.width} height={this.props.height}>
					<div style={box_style}>
						<div style={{ height: 100 }}>
							<p style={message_style}>{this.props.message}</p>
						</div>
						<div style={{ height: 50, textAlign: 'right' }}>
							<div style={{ display: 'inline-block', textAlign: 'left', color: colours.appBlue, width: 60, height: 50, cursor: 'pointer' }} onClick={(event) => this.handleOnClick(true)} > {this.props.receiver.getString('yes')} </div>
							<div style={{ display: 'inline-block', textAlign: 'left', color: colours.appBlue, width: 60, height: 50, cursor: 'pointer' }} onClick={(event) => this.handleOnClick(false)} > {this.props.receiver.getString('no')} </div>
						</div>
					</div>
				</Overlay>
			</div>
		);
	}
}